import React, { PropsWithChildren, useContext } from "react";
import "./Welcome.scss";

import { useBreakpoints } from "@evidenceb/athena-common/helpers/breakpoints";
import { Image } from "@evidenceb/athena-common/modules/Assets";
import { Button } from "@evidenceb/athena-common/design-system/Button";
import { useIntl } from "react-intl";
import useAssetsDetails from "../../../hooks/useAssetsDetails";
import { configStore } from "../../../contexts/ConfigContext";
import { commonMessages, pageTitles } from "../../../utils/messages";
import ContentWrapper from "../ContentWrapper/ContentWrapper";
import PageWrapper from "../../../components/PageWrapper/PageWrapper";
import classNames from "classnames";
import { subjectChoiceMessages } from "../messages";
import TabTitle from "../../../components/TabTitle/TabTitle";

const Welcome = () => {
    const intl = useIntl();
    const assetsDetails = useAssetsDetails();
    const {
        config: { placeholderImages, client_name },
    } = useContext(configStore);
    const { isTabletOrSmaller } = useBreakpoints();
    const title = intl.formatMessage(pageTitles.teacherSubjectChoiceWelcome, {
        client: client_name,
    });

    return (
        <Wrapper title={title}>
            <div
                className={classNames({
                    "--is-tablet-or-smaller": isTabletOrSmaller,
                })}
            >
                <h1>{title}</h1>
                <p>
                    {intl.formatMessage(subjectChoiceMessages.welcomeMessage)}
                </p>
                {isTabletOrSmaller && (
                    <div className="subject-choice__img-container">
                        <Image
                            src={placeholderImages?.teacher?.subjectChoice?.[0]}
                            alt=""
                            assetsDetails={assetsDetails}
                        />
                    </div>
                )}
                <Button
                    className="subject-choice__button-next"
                    label={intl.formatMessage(commonMessages.next)}
                    asRouterLink={{ to: "/subject-choice/selection" }}
                    variant="custom"
                    colors={{
                        background: "var(--element-evidenceb-default)",
                        text: "var(--default-black)",
                        hoverBackground: "var(--text-main-default)",
                        hoverText: "var(--default-black)",
                    }}
                />
            </div>
            {!isTabletOrSmaller && (
                <div>
                    <Image
                        src={placeholderImages?.teacher?.subjectChoice?.[0]}
                        alt=""
                        assetsDetails={assetsDetails}
                    />
                </div>
            )}
        </Wrapper>
    );
};
export default Welcome;

const Wrapper = ({ title, children }: PropsWithChildren<{ title: string }>) => (
    <PageWrapper className="subject-choice-welcome">
        <TabTitle title={title} />
        <ContentWrapper>{children}</ContentWrapper>
    </PageWrapper>
);
